// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-password-reset--password-warning {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #45753733;\n  border-radius: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
